// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EndpointsError
 */
export interface EndpointsError {
  /**
   *
   * @type {string}
   * @memberof EndpointsError
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof EndpointsError
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof EndpointsError
   */
  reason?: string;
}

/**
 * Check if a given object implements the EndpointsError interface.
 */
export function instanceOfEndpointsError(
  value: object,
): value is EndpointsError {
  return true;
}

export function EndpointsErrorFromJSON(json: any): EndpointsError {
  return EndpointsErrorFromJSONTyped(json, false);
}

export function EndpointsErrorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EndpointsError {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    message: json['message'] == null ? undefined : json['message'],
    reason: json['reason'] == null ? undefined : json['reason'],
  };
}

export function EndpointsErrorToJSON(json: any): EndpointsError {
  return EndpointsErrorToJSONTyped(json, false);
}

export function EndpointsErrorToJSONTyped(
  value?: EndpointsError | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    message: value['message'],
    reason: value['reason'],
  };
}
